module.exports = {
  controller: class PatientFooterController {

    static $inject = [
      '$ngRedux',
      '$scope',
      '$state',
      'LanguageService',
    ];

    constructor($ngRedux, $scope, $state, LanguageService) {
      this.$ngRedux = $ngRedux;
      this.$scope = $scope;
      this.$state = $state;
      this.LanguageService = LanguageService;
    }

    $onInit() {
      this.$scope.$on('$destroy', this.$ngRedux.connect(state => ({
        group: state.group,
      }))(this));
    }

    get isVisible() {
      return this.$state.current.name !== 'privacy_statement' && this.$state.current.name !== 'patient_agreement';
    }
  },
  template: `
    <footer class="footer" ng-show="$ctrl.isVisible">
    
      <div class="pre row bg-dark-grey" ng-if="$ctrl.group.mainContactNumber">
        <p translate="footer.assistance" translate-values="{ phoneNumber: $ctrl.group.mainContactNumber }"></p>
      </div>
    
      <div class="row bg-light-grey">
        <div class="wrapper">
          <div class="footer-nav">
            <div class="petal-logo">
              <span class="petal-logo" ng-include src="'main/assets/svg/petal-logo.svg'"/>
            </div><!--
            --><div class="links">
              <a ng-click="$ctrl.LanguageService.switchLanguage()" translate="switch_language"></a>
              <a ui-sref="patient_agreement" target="_blank" translate="footer.terms_and_conditions"></a>
              <a ui-sref="privacy_statement" target="_blank" translate="footer.privacy_policy"></a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  `,
};



// WEBPACK FOOTER //
// ./main/components/patient-footer.js